/**
 * Section title block: eyebrow, serif heading and an optional lead paragraph.
 *
 * "centered" and "faq" layouts stack everything; "split" and "gallery" group the
 * eyebrow and heading so the lead (or children, e.g. controls) sits beside them.
 */
export function SectionHeading({ eyebrow, title, lead, layout = "centered", children }) {
  const className = layout === "centered" ? "section-heading centered" : `section-heading ${layout}-heading`;
  const titleBlock = (
    <>
      <p className="eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
    </>
  );
  const aside = lead ? <p>{lead}</p> : children;

  if (layout === "centered" || layout === "faq") {
    return (
      <div className={className} data-reveal>
        {titleBlock}
        {aside}
      </div>
    );
  }

  return (
    <div className={className} data-reveal>
      <div>{titleBlock}</div>
      {aside}
    </div>
  );
}
